import { useState, useEffect } from "react";
import { $host } from "../../../../http";

const CreateTestModal = ({ isOpen, onClose, onSave, initialThemeId, courses, paragraphs, themes }) => {
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");

    const [selectedCourse, setSelectedCourse] = useState(null);
    const [selectedParagraph, setSelectedParagraph] = useState(null);
    const [selectedTheme, setSelectedTheme] = useState(initialThemeId || null);

    useEffect(() => {
        if (initialThemeId) {
            const foundTheme = themes.find(theme => theme.id === initialThemeId);
            if (foundTheme) {
                setSelectedTheme(initialThemeId);
                const foundParagraph = paragraphs.find(p => p.id === foundTheme.paragraph_id);
                if (foundParagraph) {
                    setSelectedParagraph(foundParagraph.id);
                    setSelectedCourse(foundParagraph.course_id);
                }
            }
        }
    }, [initialThemeId, paragraphs, themes]);

    const handleCreateTest = async () => {
        if (!selectedTheme) {
            alert("Выберите тему для теста.");
            return;
        }
        try {
            const response = await $host.post(`/api/teachers/homework/${selectedTheme}/test`, { title, description });
            onSave(response.data);
            onClose();
        } catch (error) {
            console.error("Ошибка создания теста:", error);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white p-4 rounded-md w-96">
                <h2 className="text-lg font-semibold mb-4">Создать тест</h2>

                {/* Выбор курса */}
                {!initialThemeId && (
                    <>
                        <select
                            className="border p-2 w-full mb-2"
                            value={selectedCourse || ""}
                            onChange={(e) => {
                                setSelectedCourse(e.target.value);
                                setSelectedParagraph(null);
                                setSelectedTheme(null);
                            }}
                        >
                            <option value="">Выберите курс</option>
                            {courses.map(course => (
                                <option key={course.id} value={course.id}>
                                    {course.title}
                                </option>
                            ))}
                        </select>

                        {/* Выбор параграфа */}
                        <select
                            className="border p-2 w-full mb-2"
                            value={selectedParagraph || ""}
                            onChange={(e) => {
                                setSelectedParagraph(e.target.value);
                                setSelectedTheme(null);
                            }}
                            disabled={!selectedCourse}
                        >
                            <option value="">Выберите параграф</option>
                            {paragraphs
                                .filter(p => p.course_id === selectedCourse)
                                .map(paragraph => (
                                    <option key={paragraph.id} value={paragraph.id}>
                                        {paragraph.title}
                                    </option>
                                ))}
                        </select>

                        {/* Выбор темы */}
                        <select
                            className="border p-2 w-full mb-2"
                            value={selectedTheme || ""}
                            onChange={(e) => setSelectedTheme(e.target.value)}
                            disabled={!selectedParagraph}
                        >
                            <option value="">Выберите тему</option>
                            {themes
                                .filter(t => t.paragraph_id === selectedParagraph)
                                .map(theme => (
                                    <option key={theme.id} value={theme.id}>
                                        {theme.title}
                                    </option>
                                ))}
                        </select>
                    </>
                )}

                {/* Поля ввода названия и описания теста */}
                <input
                    type="text"
                    placeholder="Название теста"
                    className="border p-2 mb-2 w-full"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    disabled={!selectedTheme}
                />
                <textarea
                    placeholder="Описание теста"
                    className="border p-2 mb-2 w-full"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    disabled={!selectedTheme}
                />

                {/* Кнопки */}
                <div className="flex justify-end gap-2">
                    <button
                        className="bg-blue-500 text-white px-4 py-2 rounded disabled:opacity-50"
                        onClick={handleCreateTest}
                        disabled={!selectedTheme || !title || !description}
                    >
                        Создать
                    </button>
                    <button className="bg-gray-400 text-white px-4 py-2 rounded" onClick={onClose}>
                        Отмена
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CreateTestModal;
